import React from 'react';

export function Title({subTitle = false, type}) {
    return (
        <div
            className={`bg--shimmer loading--title ${
                subTitle ? 'loading--title--subtitle' : ''
            }`}
        >
            {type}
        </div>
    );
}

export default Title;
